import React, { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import Categorizer from "../components/Categorizer";
import Home from "./home/Home";
import Lists from "./lists/Lists";
import RecipePage from "./recipe/RecipePage";
import Shopping from "./shopping/Shopping";
import ListPage from "./singleList/ListPage";

export default function Pages() {
  const [open, setOpen] = useState(false);
  const recipes = useSelector((state) => state.recipes);
  const [recipesLength, setRecipesLength] = useState(0);
  useEffect(() => {
    if (
      recipes.length > recipesLength &&
      recipes.some((r) => !r.hasOwnProperty("meal") || r.meal.length === 0)
    ) {
      setOpen(true);
      setRecipesLength(recipes.length);
    } else {
      setRecipesLength(recipes.length);
    }
  }, [recipes]);
  return (
    <Fragment>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/shopping" element={<Shopping />} />
        <Route path="/lists" element={<Lists />} />
        <Route path="/lists/:id" element={<ListPage />} />
        <Route path="/recipe/:id" element={<RecipePage />} />
      </Routes>
      <Categorizer open={open} setOpen={setOpen} />
    </Fragment>
  );
}
